export default (string) => string.replace(/\n/g,"<br />")
